module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-bar"
  }, [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.breadcrumbArray
    }
  })], 1), _vm._v(" "), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Items")]), _vm._v(" "), _c('div', {
    staticClass: "note note-info"
  }, [_c('p', [_vm._v("View items for category '" + _vm._s(_vm.categoryDetails.name) + "'.")])]), _vm._v(" "), (_vm.$root.permissions['menu_manager menus categories subcategories items create']) ? _c('div', {
    staticClass: "portlet box blue-hoki"
  }, [_c('div', {
    staticClass: "portlet-title bg-blue-chambray",
    on: {
      "click": function($event) {
        _vm.toggleCreateItemPanel()
      }
    }
  }, [_c('div', {
    staticClass: "custom tools"
  }, [_c('a', {
    class: {
      'expand': !_vm.createItemCollapse, 'collapse': _vm.createItemCollapse
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_vm._v("\n\t\t\t\t\t Create A New Item\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body",
    class: {
      'display-hide': _vm.createItemCollapse
    }
  }, [_c('form', {
    attrs: {
      "role": "form",
      "disabled": _vm.noItemTypes
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addNewCategoryItem()
      }
    }
  }, [_c('div', {
    staticClass: "form-body row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorMessage.length),
      expression: "errorMessage.length"
    }],
    ref: "errorMessage",
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noItemTypes),
      expression: "noItemTypes"
    }],
    ref: "noItemTypes",
    staticClass: "alert alert-info"
  }, [_vm._v("\n\t\t\t        \t\t    Menu Items require a tax classification. "), _c('router-link', {
    attrs: {
      "to": "/app/tax_manager/item_types"
    }
  }, [_vm._v("Create an Item Type in Tax Manager")]), _vm._v(" before creating a Menu Item.\n\t\t\t        \t\t")], 1)]), _vm._v(" "), (_vm.$root.activeLocation.is_corporate !== undefined && _vm.$root.activeLocation.is_corporate !== 1) ? _c('div', {
    staticClass: "col-md-12 margin-bottom-20"
  }, [_c('button', {
    staticClass: "btn create-or-edit",
    class: {
      'blue-chambray': _vm.copyMode, 'blue btn-outline': !_vm.copyMode
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.flipCopyCreate($event)
      }
    }
  }, [_vm._v("Copy existing")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    class: {
      'blue-chambray': !_vm.copyMode, 'blue btn-outline': _vm.copyMode
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.flipCopyCreate($event)
      }
    }
  }, [_vm._v("Create new")])]) : _vm._e(), _vm._v(" "), (_vm.showCorporateItems) ? _c('div', {
    staticClass: "col-md-12 margin-bottom-20"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('h4', [_vm._v("Select Menu")]), _vm._v(" "), (_vm.menus.length) ? _c('div', {
    staticClass: "dd",
    attrs: {
      "id": "nestable_list_1"
    }
  }, [_c('ol', {
    staticClass: "dd-list"
  }, _vm._l((_vm.menus), function(menu) {
    return _c('li', {
      key: menu.id,
      staticClass: "dd-item clickable",
      attrs: {
        "data-id": menu.id
      },
      on: {
        "click": function($event) {
          _vm.selectMenu(menu)
        }
      }
    }, [_c('div', {
      staticClass: "dd-handle clickable",
      class: {
        'active': menu.id === _vm.activeMenu.id
      }
    }, [_vm._v(" " + _vm._s(menu.name) + "\n\t                                    \t"), _vm._m(0, true, false)])])
  }))]) : _c('div', [_vm._m(1, false, false)])]), _vm._v(" "), (_vm.isMenuSelected) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('h4', [_vm._v("Select Category")]), _vm._v(" "), (_vm.categories.length) ? _c('div', {
    staticClass: "dd",
    attrs: {
      "id": "nestable_list_2"
    }
  }, [_c('ol', {
    staticClass: "dd-list"
  }, _vm._l((_vm.categories), function(category) {
    return _c('li', {
      key: category.id,
      staticClass: "dd-item clickable",
      attrs: {
        "data-id": category.id
      },
      on: {
        "click": function($event) {
          _vm.selectCategory(category)
        }
      }
    }, [_c('div', {
      staticClass: "dd-handle clickable",
      class: {
        'active': category.id === _vm.activeCategory.id
      }
    }, [_vm._v(" " + _vm._s(category.name) + "\n\t\t\t\t\t\t                        "), _vm._m(2, true, false)])])
  }))]) : _c('div', [_c('div', {
    staticClass: "alert alert-warning"
  }, [_c('span', [_vm._v("There are no categories in the menu '" + _vm._s(_vm.activeMenu.name) + "'.")])])])]) : _vm._e(), _vm._v(" "), (_vm.isCategorySelected) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('h4', [_vm._v("Select Item")]), _vm._v(" "), (_vm.items.length) ? _c('div', {
    staticClass: "dd",
    attrs: {
      "id": "nestable_list_3"
    }
  }, [_c('ol', {
    staticClass: "dd-list clickable"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', {
      key: item.id,
      staticClass: "dd-item clickable",
      attrs: {
        "data-id": item.id
      },
      on: {
        "click": function($event) {
          _vm.copyItem(item)
        }
      }
    }, [_c('div', {
      staticClass: "dd-handle clickable"
    }, [_c('span', {
      staticClass: "pull-left"
    }, [_c('label', {
      staticClass: "clickable"
    }, [_vm._v(_vm._s(item.name) + "\n\t\t\t\t\t\t\t                    \t")])])])])
  }))]) : _c('div', [_c('div', {
    staticClass: "alert alert-warning"
  }, [_c('span', [_vm._v("There are no items in the category '" + _vm._s(_vm.activeCategory.name) + "'.")])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showCorporateItems),
      expression: "!showCorporateItems"
    }],
    class: {
      'col-md-2': !_vm.imageMode.newMenu, 'col-md-12': _vm.imageMode.newMenu
    }
  }, [_c('resource-picker', {
    staticClass: "margin-top-15",
    attrs: {
      "imageButton": true,
      "imageUrl": _vm.newItem.image_url
    },
    on: {
      "open": function($event) {
        _vm.toggleImageMode('newMenu', true)
      },
      "close": function($event) {
        _vm.toggleImageMode('newMenu', false)
      },
      "selected": _vm.updateImage
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showCorporateItems && !_vm.imageMode.newMenu),
      expression: "!showCorporateItems && !imageMode.newMenu"
    }],
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newItem.name),
      expression: "newItem.name"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newItem.name.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_2"
    },
    domProps: {
      "value": (_vm.newItem.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newItem, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_2"
    }
  }, [_vm._v("Item Name")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newItem.desc),
      expression: "newItem.desc"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newItem.desc.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_2"
    },
    domProps: {
      "value": (_vm.newItem.desc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newItem, "desc", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_2"
    }
  }, [_vm._v("Item Description")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newItem.short_description),
      expression: "newItem.short_description"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newItem.short_description.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_2"
    },
    domProps: {
      "value": (_vm.newItem.short_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newItem, "short_description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_2"
    }
  }, [_vm._v("Item Short Description")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newItem.price),
      expression: "newItem.price"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newItem.price.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_3"
    },
    domProps: {
      "value": (_vm.newItem.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newItem, "price", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_3"
    }
  }, [_vm._v("Item Price")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newItem.nutrition_summary),
      expression: "newItem.nutrition_summary"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newItem.nutrition_summary.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_3"
    },
    domProps: {
      "value": (_vm.newItem.nutrition_summary)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newItem, "nutrition_summary", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_3"
    }
  }, [_vm._v("Nutrition Summary")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showCorporateItems && !_vm.imageMode.newMenu),
      expression: "!showCorporateItems && !imageMode.newMenu"
    }],
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newItem.order),
      expression: "newItem.order"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newItem.order
    },
    attrs: {
      "type": "number",
      "id": "form_control_4"
    },
    domProps: {
      "value": (_vm.newItem.order)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newItem, "order", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_4"
    }
  }, [_vm._v("Item Order")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newItem.sku),
      expression: "newItem.sku"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newItem.sku.length
    },
    attrs: {
      "type": "text",
      "readonly": _vm.SKUreadonly,
      "id": "form_control_5"
    },
    domProps: {
      "value": (_vm.newItem.sku)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newItem, "sku", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_5"
    }
  }, [_vm._v("Item SKU")])]), _vm._v(" "), (_vm.itemTypes.length) ? _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('label', [_vm._v("Tax class:")]), _c('br'), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "trigger": "click",
      "size": "mini",
      "show-timeout": 50,
      "hide-timeout": 50
    },
    on: {
      "command": _vm.updateTaxClass
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("\n\t                    \t\t\t\t" + _vm._s(_vm.newTaxClassLabel) + " "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l((_vm.itemTypes), function(type) {
    return _c('el-dropdown-item', {
      key: type.id,
      attrs: {
        "command": type.id
      }
    }, [_vm._v(_vm._s(type.name))])
  }))], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('label', [_vm._v("Item type:")]), _c('br'), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "trigger": "click",
      "size": "mini",
      "show-timeout": 50,
      "hide-timeout": 50
    },
    on: {
      "command": _vm.updateItemType
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.newItemTypeLabel) + " "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "regular"
    }
  }, [_vm._v("regular")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "custom"
    }
  }, [_vm._v("custom")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "preset"
    }
  }, [_vm._v("preset")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('label', [_vm._v("Item Status:")]), _c('br'), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-color": "#0c6",
      "inactive-color": "#ff4949",
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "Active",
      "inactive-text": "Sold Out"
    },
    model: {
      value: (_vm.newItem.status),
      callback: function($$v) {
        _vm.$set(_vm.newItem, "status", $$v)
      },
      expression: "newItem.status"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showCorporateItems && !_vm.imageMode.newMenu),
      expression: "!showCorporateItems && !imageMode.newMenu"
    }],
    staticClass: "form-actions right margin-top-20"
  }, [_c('button', {
    staticClass: "btn blue",
    attrs: {
      "type": "submit",
      "disabled": _vm.noItemTypes
    }
  }, [_vm._v("Create")])])])])]) : _vm._e(), _vm._v(" "), _c('loading-screen', {
    attrs: {
      "show": _vm.displayItemData,
      "color": '#2C3E50',
      "display": 'inline'
    }
  }), _vm._v(" "), (_vm.$root.activeLocation && _vm.$root.activeLocation.id && !_vm.displayItemData) ? _c('div', [_c('div', {
    staticClass: "portlet light portlet-fit bordered margin-top-20"
  }, [_c('div', {
    staticClass: "portlet-title bg-blue-chambray"
  }, [_c('div', {
    staticClass: "menu-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.categoryDetails.image_url
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "caption-subject font-green bold uppercase"
  }, [_vm._v(_vm._s(_vm.categoryDetails.name))]), _vm._v(" "), _c('div', {
    staticClass: "caption-desc font-grey-cascade"
  }, [_vm._v(_vm._s(_vm.categoryDetails.desc))])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [(_vm.categoryItems.length) ? _c('div', {
    staticClass: "mt-element-list margin-top-15"
  }, [_c('div', {
    staticClass: "mt-list-container list-news ext-1 no-border"
  }, [_c('ul', _vm._l((_vm.categoryItems), function(item) {
    return _c('li', {
      key: item.id,
      staticClass: "mt-list-item margin-top-15",
      class: {
        'no-hover-highlight': _vm.expanded === item.id, 'clickable': _vm.expanded !== item.id, 'animated': _vm.animated === ("item-" + (item.id))
      },
      attrs: {
        "id": 'item-' + item.id
      },
      on: {
        "click": function($event) {
          _vm.expandDetails(item)
        }
      }
    }, [_c('div', {
      staticClass: "margin-bottom-15 actions-on-top"
    }, [(_vm.$root.permissions['menu_manager menus categories subcategories items update']) ? _c('el-tooltip', {
      attrs: {
        "content": "Edit",
        "effect": "light",
        "placement": "bottom"
      }
    }, [_c('a', {
      staticClass: "btn btn-circle btn-icon-only btn-default",
      on: {
        "click": function($event) {
          _vm.displayEditItemModal(item, $event)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-pencil"
    })])]) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['menu_manager menus categories subcategories items read'] && !_vm.$root.permissions['menu_manager menus categories subcategories items update']) ? _c('el-tooltip', {
      attrs: {
        "content": "View",
        "effect": "light",
        "placement": "bottom"
      }
    }, [_c('a', {
      staticClass: "btn btn-circle btn-icon-only btn-default",
      on: {
        "click": function($event) {
          _vm.displayEditItemModal(item, $event)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-eye"
    })])]) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['menu_manager menus categories subcategories items update']) ? _c('el-tooltip', {
      attrs: {
        "content": "Images",
        "effect": "light",
        "placement": "bottom"
      }
    }, [_c('a', {
      staticClass: "btn btn-circle btn-icon-only btn-default",
      on: {
        "click": function($event) {
          _vm.openImagesModal(item, $event)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-image"
    })])]) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['menu_manager menus categories subcategories items update']) ? _c('el-tooltip', {
      attrs: {
        "content": "Nutrition Info",
        "effect": "light",
        "placement": "bottom"
      }
    }, [_c('a', {
      staticClass: "btn btn-circle btn-icon-only btn-default",
      on: {
        "click": function($event) {
          _vm.viewNutritionInfo(item, $event)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-heartbeat"
    })])]) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['menu_manager menus categories subcategories items update']) ? _c('el-tooltip', {
      attrs: {
        "content": "Apply To Locations",
        "effect": "light",
        "placement": "bottom"
      }
    }, [_c('a', {
      staticClass: "btn btn-circle btn-icon-only btn-default",
      on: {
        "click": function($event) {
          _vm.displayApplyToLocationsModal(item, $event)
        }
      }
    }, [_c('i', {
      staticClass: "icon-layers"
    })])]) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['menu_manager menus categories subcategories items delete']) ? _c('el-tooltip', {
      attrs: {
        "content": "Delete",
        "effect": "light",
        "placement": "bottom"
      }
    }, [_c('a', {
      staticClass: "btn btn-circle btn-icon-only btn-default",
      on: {
        "click": function($event) {
          _vm.displayDeleteItemModal(item, $event)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-trash"
    })])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.expanded !== item.id),
        expression: "expanded !== item.id"
      }],
      staticClass: "list-icon-container"
    }, [_c('i', {
      staticClass: "fa fa-angle-right",
      attrs: {
        "id": 'icon-' + item.id
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "list-thumb"
    }, [(item.image_url.length) ? _c('a', [_c('img', {
      attrs: {
        "alt": "",
        "src": item.image_url
      }
    })]) : _c('a', [_c('img', {
      attrs: {
        "src": require("../../../assets/img/app/image-placeholder.png")
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "list-datetime bold uppercase font-red"
    }, [_c('span', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticClass: "row height-mod"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('strong', [_vm._v("Price:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.price))]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("SKU:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.sku))]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Status:")]), _vm._v(" "), (item.status == 1) ? _c('span', [_vm._v("Available")]) : _vm._e(), _vm._v(" "), (item.status == 0) ? _c('span', [_vm._v("Sold Out")]) : _vm._e(), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Nutrition summary:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.nutrition_summary))]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Item type:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getItemTypeName(item.item_type_id)))])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('strong', [_vm._v("Description:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.desc))]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Short description:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.short_description))])])]), _vm._v(" "), _c('div', {
      staticClass: "row",
      class: {
        'mt-list-item-expanded': _vm.expanded === item.id, 'mt-list-item-collapsed': _vm.expanded !== item.id
      }
    }, [_c('div', {
      class: {
        'col-md-3': item.type === 'preset', 'col-md-4': item.type !== 'preset'
      }
    }, [_vm._m(3, true, false), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [(item.modifiers && item.modifiers.length) ? _c('div', [_c('ul', {
      staticClass: "item-modifier-list"
    }, _vm._l((item.modifiers), function(modifier) {
      return _c('li', {
        key: modifier.id
      }, [_c('router-link', {
        attrs: {
          "to": '/app/menu_manager/modifier_items/' + modifier.id
        }
      }, [_vm._v(_vm._s(modifier.name))])], 1)
    }))]) : _vm._e(), _vm._v(" "), (!item.modifiers || !item.modifiers.length) ? _c('div', {
      staticClass: "col-md-12"
    }, [_c('p', {
      staticClass: "grey-text"
    }, [_vm._v("No modifiers have been applied to this item.")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [(_vm.$root.permissions['menu_manager menus categories subcategories items update']) ? _c('button', {
      staticClass: "btn btn-outline btn-xs blue margin-top-10",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.showModifierModal(item.id, item.modifiers)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tAdd Modifiers\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      class: {
        'col-md-3': item.type === 'preset', 'col-md-4': item.type !== 'preset'
      }
    }, [_vm._m(4, true, false), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [(item.tags && item.tags.length) ? _c('div', [_c('ul', {
      staticClass: "item-modifier-list"
    }, _vm._l((item.tags), function(tag) {
      return _c('li', {
        key: tag.id
      }, [_c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (tag.type === 'may_contain'),
          expression: "tag.type === 'may_contain'"
        }]
      }, [_vm._v("may contain")]), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (tag.type === 'contains'),
          expression: "tag.type === 'contains'"
        }]
      }, [_vm._v("contains")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t " + _vm._s(tag.name) + " \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])
    }))]) : _vm._e(), _vm._v(" "), (!item.tags || !item.tags.length) ? _c('div', {
      staticClass: "col-md-12"
    }, [_c('p', {
      staticClass: "grey-text"
    }, [_vm._v("No tags have been applied to this item.")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [(_vm.$root.permissions['menu_manager menus categories subcategories items update']) ? _c('button', {
      staticClass: "btn btn-outline btn-xs blue margin-top-10",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.showTagsModal(item.id, item.tags)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tAdd Tags\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      class: {
        'col-md-3': item.type === 'preset', 'col-md-4': item.type !== 'preset'
      }
    }, [_vm._m(5, true, false), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.selectedItemAttributes.length),
        expression: "selectedItemAttributes.length"
      }]
    }, [_c('ul', {
      staticClass: "item-modifier-list"
    }, _vm._l((_vm.selectedItemAttributes), function(attribute) {
      return _c('li', {
        key: attribute.id,
        staticClass: "col-md-6"
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t " + _vm._s(attribute.name) + " \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])
    }))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.selectedItemAttributes.length),
        expression: "!selectedItemAttributes.length"
      }],
      staticClass: "col-md-12"
    }, [_c('p', {
      staticClass: "grey-text"
    }, [_vm._v("No attributes have been applied to this item.")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [(_vm.$root.permissions['menu_manager menus categories subcategories items update']) ? _c('button', {
      staticClass: "btn btn-outline btn-xs blue margin-top-10",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.showAttributesModal(item)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tAdd Attributes\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.type === 'preset'),
        expression: "item.type === 'preset'"
      }],
      staticClass: "col-md-3"
    }, [_c('h5', [_vm._v("Preset Settings")]), _vm._v(" "), _c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.preset_item_modifier_item),
        expression: "item.preset_item_modifier_item"
      }],
      staticClass: "item-modifier-list"
    }, _vm._l((item.preset_item_modifier_item), function(modifier, index) {
      return _c('li', {
        key: index
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(modifier.modifier_item_name) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"), (modifier.preset_item_modifier_item_option_item.length > 0) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t("), _vm._l((modifier.preset_item_modifier_item_option_item), function(option, index) {
        return _c('span', {
          key: index
        }, [_vm._v(_vm._s(option.option_item_name)), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (modifier.preset_item_modifier_item_option_item.length - 1 !== index),
            expression: "modifier.preset_item_modifier_item_option_item.length - 1 !== index"
          }]
        }, [_vm._v(" | ")])])
      }), _vm._v(")\n\t\t\t\t\t\t\t\t\t\t\t\t\t")], 2) : _vm._e()])
    })), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.preset_item_modifier_item && !item.preset_item_modifier_item.length),
        expression: "item.preset_item_modifier_item && !item.preset_item_modifier_item.length"
      }],
      staticClass: "grey-text"
    }, [_vm._v("No preset settings yet.")]), _vm._v(" "), (_vm.$root.permissions['menu_manager menus categories subcategories items update']) ? _c('button', {
      staticClass: "btn btn-outline btn-xs blue margin-top-10",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.showPresetModal(item)
        }
      }
    }, [(item.preset_item_modifier_item && !item.preset_item_modifier_item.length) ? _c('span', [_vm._v("Add")]) : _c('span', [_vm._v("Edit")]), _vm._v(" Preset Settings\n\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()])])])
  }))])]) : _c('div', {
    staticClass: "margin-top-20"
  }, [_c('no-results', {
    attrs: {
      "show": !_vm.categoryItems.length,
      "type": 'items',
      "custom": true,
      "text": _vm.customText
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (!_vm.displayItemData) ? _c('div', {
    staticClass: "margin-top-20"
  }, [_c('no-results', {
    attrs: {
      "show": !_vm.$root.activeLocation || !_vm.$root.activeLocation.id,
      "type": 'items'
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.editItemModalActive) ? _c('edit-item', {
    on: {
      "editItem": _vm.editItem,
      "deactivateEditItemModal": _vm.closeEditItemModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.deleteItemModalActive) ? _c('delete-item', {
    attrs: {
      "passedItemId": _vm.passedItemId
    },
    on: {
      "closeDeleteItemModal": _vm.closeDeleteItemModal,
      "deleteItemAndCloseModal": _vm.deleteItemAndCloseModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.displayNutritionModal) ? _c('nutrition-info', {
    attrs: {
      "item": _vm.selectedItem
    },
    on: {
      "nutritionInfoSaved": _vm.nutritionInfoSaved,
      "deactivateNutritionInfoModal": function($event) {
        _vm.displayNutritionModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.displayModifierModal) ? _c('modifiers-list', {
    attrs: {
      "appliedModifiers": _vm.appliedModifiers,
      "selectedItemId": _vm.selectedItemId
    },
    on: {
      "deactivateModifierModal": _vm.closeModifierModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.displayTagsListModal) ? _c('tags-list', {
    attrs: {
      "appliedTags": _vm.appliedTags,
      "selectedItemId": _vm.selectedItemId
    },
    on: {
      "deactivateTagsListModal": _vm.closeTagsListModal
    }
  }) : _vm._e(), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.showAssignItemAttributesModal,
      "effect": "fade"
    },
    on: {
      "closeOnEscape": _vm.closeAssignItemAttributesModal
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeAssignItemAttributesModal()
      }
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title center"
  }, [_vm._v("Apply Attributes")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.assignItemAttributesErrorMessage.length),
      expression: "assignItemAttributesErrorMessage.length"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.clearAttributesError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.assignItemAttributesErrorMessage))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "table-column--checkboxes"
  }, [_c('div', {
    staticClass: "md-checkbox has-success",
    on: {
      "change": function($event) {
        _vm.selectAllAttributes()
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAllAttributesSelected),
      expression: "selectAllAttributesSelected"
    }],
    staticClass: "md-check",
    attrs: {
      "type": "checkbox",
      "id": "locations-promocodes"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAllAttributesSelected) ? _vm._i(_vm.selectAllAttributesSelected, null) > -1 : (_vm.selectAllAttributesSelected)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.selectAllAttributesSelected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAllAttributesSelected = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectAllAttributesSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAllAttributesSelected = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "locations-promocodes"
    }
  }, [_c('span', {
    staticClass: "inc"
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "box"
  })])])]), _vm._v(" "), _c('th', [_vm._v(" Name ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.itemAttributes), function(itemAttribute) {
    return _c('tr', {
      key: itemAttribute.id
    }, [_c('td', {
      staticClass: "table-column--names"
    }, [_c('div', {
      staticClass: "md-checkbox has-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (itemAttribute.selected),
        expression: "itemAttribute.selected"
      }],
      staticClass: "md-check",
      attrs: {
        "type": "checkbox",
        "id": ("ia-" + (itemAttribute.id))
      },
      domProps: {
        "checked": Array.isArray(itemAttribute.selected) ? _vm._i(itemAttribute.selected, null) > -1 : (itemAttribute.selected)
      },
      on: {
        "change": [function($event) {
          var $$a = itemAttribute.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (itemAttribute.selected = $$a.concat([$$v]))
            } else {
              $$i > -1 && (itemAttribute.selected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(itemAttribute, "selected", $$c)
          }
        }, function($event) {
          _vm.syncSelectAllAttributes(itemAttribute.selected)
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": ("ia-" + (itemAttribute.id))
      }
    }, [_c('span', {
      staticClass: "inc"
    }), _vm._v(" "), _c('span', {
      staticClass: "check"
    }), _vm._v(" "), _c('span', {
      staticClass: "box"
    })])])]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(itemAttribute.name) + " ")])])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer clear",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn blue pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.assignItemAttributesToItem()
      }
    }
  }, [_vm._v("Save")])])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.applyToLocationsModalActive,
      "effect": "fade"
    },
    on: {
      "closeOnEscape": _vm.closeApplyToLocationsModal
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeApplyToLocationsModal()
      }
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title center"
  }, [_vm._v("Apply Item To Locations")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.applyToLocationsErrorMessage.length),
      expression: "applyToLocationsErrorMessage.length"
    }],
    ref: "applyToLocationsErrorMessage",
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.clearLocationsError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.applyToLocationsErrorMessage))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('select-locations-popup', {
    attrs: {
      "previouslySelected": _vm.locationsToApplyItemTo,
      "withButton": false
    },
    on: {
      "selectedLocations": _vm.selectedLocations
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer clear",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn blue pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.applyItemToLocations()
      }
    }
  }, [_vm._v("Apply")])])])])]), _vm._v(" "), (_vm.displayImagesModal) ? _c('item-images', {
    attrs: {
      "item": _vm.selectedItem
    },
    on: {
      "closeImagesModal": _vm.closeImagesModal,
      "closeImagesModalAndUpdate": _vm.closeImagesModalAndUpdate
    }
  }) : _vm._e(), _vm._v(" "), (_vm.displayPresetModal) ? _c('preset-settings', {
    attrs: {
      "item": _vm.itemToSetPresetSettingsFor
    },
    on: {
      "closePresetModal": _vm.closePresetModal,
      "closeAndUpdate": _vm.closePresetModalAndUpdate
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right"
  }, [_c('i', {
    staticClass: "fa fa-chevron-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('span', [_vm._v("There are no menus to display.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right"
  }, [_c('i', {
    staticClass: "fa fa-chevron-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('h5', {
    staticClass: "inline-block"
  }, [_vm._v("Modifiers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('h5', {
    staticClass: "inline-block"
  }, [_vm._v("Tags")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('h5', {
    staticClass: "inline-block"
  }, [_vm._v("Attributes")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4172762"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/MenuManager/Items.vue
// module id = 794
// module chunks = 0